var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:({
    position: 'absolute',
    width: 0,
    height: 0,
    left: _vm.left + 'px',
    top: _vm.top + 'px'
  })},[_vm._t("crossRegionMenu")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }